import type {
	SidebarConfigData,
	SidebarConfigQuery,
} from '@atlassian/jira-navigation-types/src/types.tsx';
import { fetchSidebarConfig } from '@atlassian/jira-router-resources-sidebar-config/src/index.tsx';
import { getProjectKeyId } from '@atlassian/jira-router-resources-utils/src/utils/get-project-key-id/index.tsx';
import { createResource } from '@atlassian/react-resource-router';
import { RESOURCE_TYPE_NAVIGATION_SIDEBAR_GLOBAL } from './constants.tsx';

type DataType = {
	response: SidebarConfigData;
	scope: SidebarConfigQuery;
};
export const navigationSidebarGlobalResource = createResource<DataType>({
	type: RESOURCE_TYPE_NAVIGATION_SIDEBAR_GLOBAL,
	getKey: ({ match, query }) => {
		// Refresh the data if the project key or id changes
		const { projectKey, projectId } = getProjectKeyId(match, query);
		return projectKey || projectId || '__state';
	},
	getData: async ({ match, query }, { tenantContext }) => {
		const { baseUrl } = tenantContext;
		const { projectKey, projectId } = getProjectKeyId(match, query);
		const scope: SidebarConfigQuery = {
			projectKey,
			projectId,
		};
		const response = await fetchSidebarConfig(baseUrl, scope, __SERVER__);

		return {
			response,
			scope,
		};
	},
	maxAge: 5 * 60 * 1000,
});
